import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {MenuCatType} from '../types';

export const useGetMenuCat = (): {menuCatLoading: boolean; menuCat: MenuCatType[]} => {
  const [menuCat, setMenuCat] = useState<MenuCatType[]>([]);
  const [menuCatLoading, setMenuCatLoading] = useState<boolean>(false);

  const getMenu = async () => {
    setMenuCatLoading(true);

    try {
      const response = await axios.get(URLS.GET_MENU_CAT_LOCAL);
      setMenuCat(response.data.menuCat);
    } catch (error) {
      console.error(error);
    } finally {
      setMenuCatLoading(false);
    }
  };

  useEffect(() => {
    getMenu();
  }, []);

  return {menuCatLoading, menuCat};
};
